import Tippy from "@tippyjs/react";
import { DataTable } from "mantine-datatable";
import { useEffect, useState } from "react";
import { LabelStatusCustom } from "../../../components/custom/label-status-custom";
import SearchCustom from "../../../components/custom/search-custom";
import { IconActive, IconEdit, IconEye, IconReset, IconUnActive } from "../../../components/icons/icon-group";
import { CHANGE_STATUS, PAGE_SIZES, STATUS } from "../../../constants/status";
import { BrandResponse } from "../../../models/response/brand-response";

interface BrandTableProps {
  loadingTable: boolean;
  dataBrand: BrandResponse[];
  page: number;
  setPage: (value: number) => void;
  limit: number;
  setLimit: (value: number) => void;
  keySearch: string;
  setKeySearch: (value: string) => void;
  totalRecords: number;
  setOpenModalUpdate: (value: boolean) => void;
  setOpenModalDetail: (value: boolean) => void;
  setOpenModalChangeStatus: (value: boolean) => void;
  setDataObject: (value: BrandResponse) => void;
  setIsOpenResetPass: (value: boolean) => void;
}

export const BrandTable = (props: BrandTableProps) => {
  const [tableMaxHeight, setTableMaxHeight] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const header = document.querySelector(".navbar") as HTMLElement;
      const tab = document.getElementById("tab-menu") as HTMLElement;
      if (header && tab) {
        const headerHeight = header.offsetHeight;
        const tabHeight = tab.offsetHeight;
        const remainingHeight = window.innerHeight - headerHeight - tabHeight - 150;
        setTableMaxHeight(remainingHeight);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChangeStatus = (id: string, typeAdmin: number) => {
    const selectedData = props.dataBrand.find((item) => item._id === id) as BrandResponse;
    props.setDataObject(selectedData);
    switch (typeAdmin) {
      case CHANGE_STATUS.UPDATE:
        props.setOpenModalUpdate(true);
        break;
      case CHANGE_STATUS.ACTIVE:
      case CHANGE_STATUS.INACTIVE:
        props.setOpenModalChangeStatus(true);
        break;
      case CHANGE_STATUS.RESET:
        props.setIsOpenResetPass(true);
        break;
      case CHANGE_STATUS.DETAIL:
        props.setOpenModalDetail(true);
        break;
      default:
        break;
    }
  };
  return (
    <div className="panel flex flex-col gap-3">
      <div className="flex justify-end items-center">
        <SearchCustom value={props.keySearch} onChange={(e) => props.setKeySearch(e)} className="w-full md:w-64" />
      </div>
      <div className="datatables" style={{ height: tableMaxHeight }}>
        <DataTable
          fetching={props.loadingTable}
          withColumnBorders
          noRecordsText="No results match your search query"
          highlightOnHover
          className="whitespace-nowrap table-hover"
          records={props.dataBrand}
          columns={[
            {
              accessor: "",
              title: "STT",
              render: (record, index) => <div>{(props.page - 1) * props.limit + index + 1}</div>,
            },
            {
              accessor: "name",
              title: "Tên thương hiệu",
            },
            { accessor: "identifier_name", title: "Tên định danh" },
            {
              accessor: "company",
              title: "Tên công ty",
              render: (record) => <div>{record.company.name}</div>,
            },
            { accessor: "phone", title: "Số điện thoại" },

            {
              accessor: "status",
              title: "Trạng thái",
              titleClassName: "!text-center",
              render: ({ status }) => (
                <LabelStatusCustom
                  content={status === 1 ? "Đang hoạt động" : "Tạm ngưng"}
                  backgroundColor={status ? "bg-green-200" : "bg-red-200"}
                  textColor={status ? "text-green-600" : "text-red-600"}
                />
              ),
              width: 150,
            },
            {
              accessor: "action",
              title: "Action",
              titleClassName: "!text-center",
              render: ({ status, _id }) => {
                return (
                  <div className="flex items-center w-max mx-auto gap-2">
                    <Tippy content="Reset mật khẩu">
                      <button
                        disabled={status === STATUS.INACTIVE}
                        type="button"
                        onClick={() => {
                          handleChangeStatus(_id, CHANGE_STATUS.RESET);
                        }}
                        className={`${status === STATUS.INACTIVE ? "opacity-50 cursor-not-allowed" : ""}`}
                      >
                        <IconReset />
                      </button>
                    </Tippy>
                    <Tippy content="Chỉnh sửa">
                      <button
                        disabled={status === STATUS.INACTIVE}
                        type="button"
                        onClick={() => {
                          handleChangeStatus(_id, CHANGE_STATUS.UPDATE);
                        }}
                        className={`${status === STATUS.INACTIVE ? "opacity-50 cursor-not-allowed" : ""}`}
                      >
                        <IconEdit />
                      </button>
                    </Tippy>
                    <Tippy content="Chi tiết">
                      <button
                        type="button"
                        onClick={() => {
                          handleChangeStatus(_id, CHANGE_STATUS.DETAIL);
                        }}
                      >
                        <IconEye />
                      </button>
                    </Tippy>

                    {status === STATUS.ACTIVE ? (
                      <Tippy content="Tạm ngưng">
                        <button
                          type="button"
                          onClick={() => {
                            handleChangeStatus(_id, CHANGE_STATUS.INACTIVE);
                          }}
                        >
                          <IconUnActive />
                        </button>
                      </Tippy>
                    ) : (
                      <Tippy content="Bật hoạt động">
                        <button
                          type="button"
                          onClick={() => {
                            handleChangeStatus(_id, CHANGE_STATUS.ACTIVE);
                          }}
                        >
                          <IconActive />
                        </button>
                      </Tippy>
                    )}
                  </div>
                );
              },
            },
          ]}
          totalRecords={props.totalRecords}
          recordsPerPage={props.limit}
          page={props.page}
          onPageChange={(p) => props.setPage(p)}
          recordsPerPageOptions={PAGE_SIZES}
          onRecordsPerPageChange={props.setLimit}
          minHeight={200}
          paginationText={({ from, to, totalRecords }) => `Hiển thị ${from} đến ${to} của ${totalRecords} hàng`}
        />
      </div>
    </div>
  );
};
